<div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div class="card-body">
      <div class="row align-items-center mb-3 d-flex justify-content-between">
        <h2 class="custom-card-title headLeft">Events</h2>
        <!-- Search -->
        <div class="col-12 col-md-5 mb-3 headLeft">
          <input type="text" class="form-control" placeholder="Search events..."
                 [(ngModel)]="searchValue"
                 (ngModelChange)="filter(searchValue)">
        </div>

        <div class="col-12 col-md-5 mb-3 d-flex justify-content-md-end gap-2 headRight">
          <select *ngIf="teacher?.role === 'Admin'" class="form-select mb-3" (change)="showEvents($event)">
            <option selected value="All Events">All Events</option>
            <option value="Deleted">Deleted</option>
            <option value="Undeleted">Undeleted</option>
          </select>

          <div class="flex-shrink-0">
            <a routerLink="/events-form" class="btn btn-primary d-flex align-items-center"
               *ngIf="(teacher?.role ?? '').toLowerCase() === 'admin'">
              New Event
              <span class="material-symbols-outlined ms-1">add</span>
            </a>
          </div>

          <div class="flex-shrink-1" style="min-width: 100px;">
            <select class="form-select" aria-label="Number of cards per page" (change)="selectChange($event)">
              <option selected value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="All">All</option>
            </select>
          </div>
        </div>

        <div style="margin: 0" id="row-section">
          <div>
            <table class="table">
              <thead>
              <tr>
                <th (click)="sort('status')">
                  <select class="form-select form-select-sm" (change)="onStatusSortChange($event)">
                    <option value="">Event Status</option>
                    <option *ngFor="let status of eventStatusOrder" [value]="status">{{ status }}</option>
                  </select>
                </th>
                <th (click)="sort('name')">
                  Event Name
                  <span *ngIf="getSortDir('name') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('name') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('name') !== 'desc' && getSortDir('name') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('start')">
                  Event Start Date
                  <span *ngIf="getSortDir('start') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('start') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('start') !== 'desc' && getSortDir('start') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('end')">
                  Event End Date
                  <span *ngIf="getSortDir('end') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('end') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('end') !== 'desc' && getSortDir('end') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('link')">
                  Event Web Link
                  <span *ngIf="getSortDir('link') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('link') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('link') !== 'desc' && getSortDir('link') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
              </tr>
              </thead>
              <tbody *ngIf="pagedCards.length > 0; else noEvents">
              <ng-container *ngFor="let event of pagedCards; let i = index">

                <tr (click)="onEventClicked(event)">
                  <td>{{ event.status }}</td>
                  <td>{{ event.name }}</td>
                  <td>{{ event.startDate | date:'MMM d, yyyy' }}</td>
                  <td>{{ event.endDate | date:'MMM d, yyyy' }}</td>
                  <td>
                    <a [href]="event.webLink" target="_blank" rel="noopener">
                      {{ event.webLink }}
                    </a>
                  </td>
                </tr>

              </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination (only if more than one page) -->
        <ul class="pagination headLeft" *ngIf="totalPages > 1">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="goToPrevious()">Previous</a>
          </li>

          <li
            *ngFor="let page of pages"
            class="page-item"
            [class.active]="page === currentPage"
          >
            <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
          </li>

          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="goToNext()">Next</a>
          </li>
        </ul>

        <ng-template #noEvents>
          <div class="col-12">
            <p class="mb-4">There are no events.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

